import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { ApartmentType } from '../../../graphql/graphql';
import {
  ApartmentItem,
  ApartmentItemValue,
  ApartmentTypesContainer,
  ApartmentTypesOuter
} from './styled';
import { Typography } from '../../ui/Typography';
import { prettyNumber } from '../../../utils/helpers';
import { useDragScroll } from '../../../hooks/useDragScroll';

interface ResidenceApartmentTypesProps {
  apartmentTypes: ApartmentType[];
  handleSelectRooms: (value: number) => void;
}

export const ResidenceApartmentTypes: React.FC<
  ResidenceApartmentTypesProps
> = ({ apartmentTypes, handleSelectRooms }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { ref, bind, hasMovedRef } = useDragScroll<HTMLDivElement>();

  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    rooms: number
  ) => {
    if (hasMovedRef.current) return;

    e.preventDefault();
    e.currentTarget.blur();
    handleSelectRooms(rooms);

    const element = document.getElementById('ap-filter');

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <ApartmentTypesOuter>
      <ApartmentTypesContainer ref={ref} {...bind}>
        {apartmentTypes.map(apartmentType => {
          const apartmentTypeTitle = t('pages.residence.rooms_count', {
            count: apartmentType.rooms
          });
          const price = `${prettyNumber(apartmentType.priceFrom)} ${apartmentType.currency}`;

          return (
            <ApartmentItem key={apartmentTypeTitle}>
              <Typography tag="body_1">{apartmentTypeTitle}</Typography>
              <ApartmentItemValue
                onClick={e => handleClick(e, apartmentType.rooms)}
                href={{
                  pathname: router.pathname,
                  query: {
                    ...router.query,
                    rooms: apartmentType.rooms,
                    page: 1
                  }
                }}
              >
                {t('pages.residence.from_price', { price })}
              </ApartmentItemValue>
            </ApartmentItem>
          );
        })}
      </ApartmentTypesContainer>
    </ApartmentTypesOuter>
  );
};
